export const MAX_BOTTOM_SHEET_ITEMS = 5;
